export const keyResultFinalitysOptions = {
	Aumentar: 1,
	Reduzir: 2,
	Manter: 3,
	Entregar: 4,
};
